import { type ComponentChildren } from 'preact'
import { useRoute } from 'wouter-preact'

import { projectsState } from 'state'

import { Header, LeftSidebar } from './components'

type LayoutProps = {
	children: ComponentChildren
}

const Layout = ({ children }: LayoutProps) => {
	const [isHomePage] = useRoute('/')
	const [isdAppsPage] = useRoute('/dapps')

	const hasProjects = !!projectsState.value?.length

	return (
		<div class='flex h-screen flex-col bg-black-900'>
			<Header />

			<div class='flex flex-1 overflow-hidden'>
				<div class='w-72 flex-shrink-0 overflow-y-auto'>
					<LeftSidebar
						hasProjects={hasProjects}
						isdAppsPage={isdAppsPage}
						isHome={isHomePage}
					/>
				</div>

				<main class='flex-1 overflow-y-auto px-8 py-8 2xl:px-0'>
					<div class='mx-auto max-w-[1060px]'>{children}</div>
				</main>
			</div>
		</div>
	)
}

export { Layout }
